export const GobArApi = () => {
    const domain = 'https://apis.datos.gob.ar/georef/api'

    const getProvinces = async () => {
        const response = await fetch(`${domain}/provincias?aplanar=true&max=5000`)
        if (response.status === 429) {
            throw new Error(`GobAr Error: Too many requests.`)
        }
        return response.json()
    }

    const getLocalities = async () => {
        const response = await fetch(`${domain}/localidades?aplanar=true&max=5000`)
        if (response.status === 429) {
            throw new Error(`GobAr Error: Too many requests.`)
        }
        return response.json()
    }
    
    return {
        getProvinces,
        getLocalities
    }
}
